import React, { useState, useEffect } from "react";
import {
  Container,
  Popup,
  Button,
  Responsive,
  Message,
  Loader,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { getProductDetail } from "../../redux/actions/productDetail";
import { getCosts } from "../../redux/actions/payment";
import {
  formatCurrency,
  formatterUSD,
} from "../../commons/functions/generalFunctions";
import {
  addProduct,
  removeProduct,
  handleOneProduct,
} from "../../redux/actions/cart";
import DesktopImgs from "./components/DesktopImgs";
import MovilImgs from "./components/MovilImgs";
import {
  addWishlistItem,
  removeWishlistItem,
  getWishlist,
} from "../../redux/actions/wishlist";
import "../styles/formProduct.css";
import "./styles.css";
import { withRouter } from "react-router-dom";
//carousel Accessories
import CarouselAccesories from "./components/CarouselAccessories/CarouselAccessories";

//SendHint
import SendHint from "./components/SendHint/SendHint";

import Error from "../../components/Error/error";

import { daysRestriction } from "./../../commons/helpers/daysRestriction";

const myTrim = (x) => {
  return x.replace(/^\s+|\s+$/gm, "");
};

const replaceSpaces = (text) => {
  var str = myTrim(text);
  return str;
};

const ProductPay = (props) => {
  let {
    getProductDetail,
    location,
    currencySelect,
    productDetail,
    categories,
    getWishlist,
    cart,
    removeProduct,
    // customizationCost,
    getCosts,
    addWishlistItem,
    removeWishlistItem,
    auth,
    wishlist,
    history,
  } = props;

  //const nCaracteres = 28;
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [text, setText] = useState("");
  const [image, setImage] = useState("");
  const [currencyValue, SetCurrencyValue] = useState(0);
  const [selectorImage, setSelectorImage] = useState(0);
  const [existCart, setExistCart] = useState(false);
  const [validWords, setValidWords] = useState(true);
  const [showCT, setShowCT] = useState(true);
  const [validBasket, setValidBasket] = useState(true);
  const [wishlistSwitchLoading, setWishlistSwitchLoading] = useState(false);

  const checkAdded = () => {
    if (
      Array.isArray(wishlist.data) &&
      wishlist.data.some((item) => {
        return item.productId === productDetail.id;
      })
    ) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (auth.isLoaded) {
      getWishlist();
    }
  }, [auth.isLoaded, getWishlist]);

  const wishlistSwitch = () => {
    if (auth.isEmpty) {
      history.push("/login");
    } else {
      setWishlistSwitchLoading(true);
      if (checkAdded()) {
        removeWishlistItem(productDetail.id).then(() => {
          setWishlistSwitchLoading(false);
        });
      } else {
        addWishlistItem(productDetail.id, {
          ...productDetail.data,
          productId: productDetail.id,
        }).then(() => {
          setWishlistSwitchLoading(false);
        });
      }
    }
  };

  useEffect(() => {
    if (!loading && !wishlist.isLoading && !auth.isLoading) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [loading, wishlist.isLoading, auth.isLoading]);

  useEffect(() => {
    setExistCart(false);
    if (cart.cart && productDetail.id) {
      cart.cart.map((item) => {
        if (item.id === productDetail.id) {
          setExistCart(true);
        }
        return null;
      });
    }
  }, [cart, productDetail]);

  useEffect(() => {
    if (productDetail.id && productDetail.data) {
      const imagen = JSON.parse(productDetail.data.images[0]).url;
      setImage(imagen);
    }
  }, [productDetail]);

  useEffect(() => {
    const trigger = async () => {
      await getProductDetail(location.pathname.split("/")[2]);
      setLoading(false);
    };
    trigger();
  }, [getProductDetail, location]);

  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);

  useEffect(() => {
    setShowCT(true);
    categories.forEach((category) => {
      if (productDetail.data && productDetail.data[category.id]) {
        if (!category.data.showCustomText) {
          setShowCT(false);
        }
      }
    });
  }, [categories, productDetail]);

  useEffect(() => {
    getCosts();
  }, [getCosts]);

  /*   const validateWords = (text) => {
    if (replaceSpaces(text).length <= nCaracteres) {
      setValidWords(true);
    } else {
      setValidWords(false);
    }
  };
 */
  /*   const handleTextChange = (e) => {
    validateWords(e.target.value);
    setText(e.target.value);
  }; */

  const testCategories = (data) => {
    if (productDetail.id) {
      let dataArray = data;
      let arrayIds = [];
      for (var i = 0; i < dataArray.length; i++) {
        if (productDetail.data[dataArray[i].id] && productDetail !== {}) {
          arrayIds.push(dataArray[i].id);
        }
      }
      if (arrayIds.length) {
        return arrayIds;
      }
    }
  };

  const hanbleRemoveProduct = (id) => {
    removeProduct(id);
    setExistCart(false);
  };

  const reviewCart = async (cart, product) => {
    let numberArrangements = 0;
    await cart.forEach((item) => {
      if (item.type === "arrangement") {
        numberArrangements = numberArrangements + 1;
      }
    });
    if (product.type === "arrangement") {
      numberArrangements = numberArrangements + 1;
    }
    setValidBasket(numberArrangements > 0 ? true : false);
    numberArrangements > 0 &&
      props.addProduct(props.cart.cart, product) &&
      setText("");
  };

  return (
    <div className="container-Sections">
      <Container
        className="locationDisplayNavbar"
        style={{
          width: "90%",
        }}
      >
        {loading ? (
          <div className="loader-container">
            <Loader
              style={{ alignSelf: "center" }}
              size="large"
              inline="centered"
              active
            />
          </div>
        ) : productDetail.data ? (
          <div>
            <div>
              <div className="product-pay-selector-device">
                <Responsive
                  className="product-pay-responsive-desktop"
                  minWidth={1024}
                >
                  <DesktopImgs
                    selectorImage={selectorImage}
                    setSelectorImage={setSelectorImage}
                    productDetail={productDetail}
                  />
                </Responsive>
                <Responsive
                  className="product-pay-responsive-movil"
                  maxWidth={1023}
                >
                  <MovilImgs
                    selectorImage={selectorImage}
                    setSelectorImage={setSelectorImage}
                    productDetail={productDetail}
                  />
                </Responsive>
                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 text-center p-5">
                  <div>
                    <img
                      src="/assets/logo-spiral.png"
                      style={styles.logo}
                      alt="logo-fh"
                    />
                  </div>
                  <div className="text-left">
                    <h3>
                      {productDetail?.data
                        ? `${
                            productDetail?.data.code
                              ? productDetail?.data.code
                              : ""
                          } ${productDetail?.data.name}`
                        : null}
                    </h3>
                    <p
                      style={{
                        fontWeight: "bold",
                        fontSize: "x-large",
                      }}
                    >
                      {productDetail?.data
                        ? props.currencySelect.loading
                          ? "Cargando..."
                          : currencyValue === 0
                          ? formatCurrency(Math.ceil(productDetail?.data.price))
                          : formatterUSD.format(
                              Math.ceil(
                                productDetail?.data.price /
                                  currencyValue.data.value
                              ) - 0.01
                            )
                        : null}
                    </p>
                    <div>
                      <p className="text-justify">
                        {productDetail?.data
                          ? productDetail?.data.description
                          : null}
                      </p>
                    </div>
                  </div>
                  <div className="text-left row p-3 container-quantity">
                    <p className="pr-4 h5">Cantidad:</p>
                    <Button.Group>
                      <Button
                        disabled={
                          existCart ? true : quantity === 1 ? true : false
                        }
                        onClick={() => setQuantity(quantity - 1)}
                      >
                        -
                      </Button>
                      <Button.Or text={quantity} />
                      <Button
                        disabled={existCart}
                        onClick={() => setQuantity(quantity + 1)}
                      >
                        +
                      </Button>
                    </Button.Group>
                  </div>
                  {/*  <div
                    className="text-left pt-3 pb-3"
                    hidden={
                      productDetail.data
                        ? !showCT
                          ? true
                          : productDetail.data &&
                            productDetail.data.type === "accessories"
                          ? true
                          : false
                        : false
                    }
                  >
                    <p className="mr-3 h5">
                      Texto personalizado:{" "}
                      <Popup
                        content={`Introduzca el mensaje con el que le gustaría personalizar la base del arreglo. Solo puede agregar ${nCaracteres} caracteres.`}
                        trigger={
                          <Button
                            circular
                            icon="info"
                            size="mini"
                            color="grey"
                          />
                        }
                      />
                    </p>
                    <input
                      disabled={
                        existCart || (productDetail.data ? !showCT : true)
                      }
                      type="text"
                      className="form-control"
                      placeholder="Personalice su base."
                      value={text}
                      onChange={(e) => handleTextChange(e)}
                    />
                    {replaceSpaces(text).length <= 0 ? null : (
                      <Message info style={{ height: "100%" }}>
                        <Message.Header>
                          Costo de personalización
                        </Message.Header>
                        <p>{`La personalización de la base del arreglo tiene un costo de ${
                          productDetail.data
                            ? props.currencySelect.loading
                              ? "Cargando..."
                              : currencyValue === 0
                              ? formatCurrency(Math.ceil(customizationCost))
                              : formatterUSD.format(
                                  Math.ceil(
                                    customizationCost / currencyValue.data.value
                                  ) - 0.01
                                )
                            : null
                        }`}</p>
                      </Message>
                    )}

                    {validWords ? null : (
                      <Message
                        negative
                        header="Se exedió el límite"
                        content={`Solo puede agregar un máximo de ${nCaracteres} caracteres.`}
                      />
                    )}
                  </div> */}
                  {existCart ? (
                    <div className="pt-2 pb-2">
                      <SendHint />
                      <button
                        className="btn btn-red w-100"
                        style={styles.btnAddCart}
                        onClick={() => hanbleRemoveProduct(productDetail.id)}
                      >
                        Remover del carrito
                      </button>
                    </div>
                  ) : (
                    <div className="pt-2 pb-2">
                      {image ? (
                        <SendHint detalleproducto={image !== "" && image} />
                      ) : null}
                      <button
                        disabled={
                          (productDetail.data
                            ? productDetail.data.available
                              ? false
                              : true
                            : null) ||
                          !validWords ||
                          daysRestriction()
                        }
                        className="btn btn-blue w-100"
                        style={styles.btnAddCart}
                        onClick={() =>
                          reviewCart(props.cart.cart, {
                            id: productDetail && productDetail.id,
                            quantity: quantity,
                            image: JSON.parse(
                              props.productDetail.data.images[0]
                            ).url,
                            name: productDetail.data.name,
                            code: productDetail.data.code,
                            price: productDetail.data.price,
                            customText:
                              productDetail &&
                              productDetail.data.type === "accessories"
                                ? ""
                                : replaceSpaces(text),
                            type: productDetail.data.type,
                            cartPosition: new Date().getTime(),
                          })
                        }
                      >
                        Agregar al carrito
                      </button>
                    </div>
                  )}

                  <div>
                    {!validBasket && (
                      <Message negative>
                        <Message.Header>¡Lo sentimos!</Message.Header>
                        <p>
                          Para poder comprar un accesorio debe tener un arreglo
                          en su canasta.
                        </p>
                      </Message>
                    )}

                    {productDetail.data.type !== "accessories" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          icon={!checkAdded() ? "heart outline" : "heart"}
                          basic
                          color={checkAdded() ? "red" : "grey"}
                          onClick={wishlistSwitch}
                          loading={wishlistSwitchLoading}
                          content={
                            !checkAdded()
                              ? "Agregar a la wishlist"
                              : "Quitar de la wishlist"
                          }
                        />
                        <div>
                          <Popup
                            content={`Agrega este producto a tu sección de favoritos.`}
                            trigger={
                              <Button
                                circular
                                icon="info"
                                size="mini"
                                color="grey"
                              />
                            }
                          />
                        </div>
                      </div>
                    )}
                    {false && (
                      <button
                        className="btn btn-dark w-100"
                        style={styles.btnAddCart}
                      >
                        Comprar ahora
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <Container className="div-accessories">
                <CarouselAccesories categoryid={testCategories(categories)} />
              </Container>
            </div>
          </div>
        ) : (
          <Error />
        )}
      </Container>
    </div>
  );
};

const styles = {
  logo: {
    width: 72,
    height: 58,
  },
  btnAddCart: {
    pading: 30,
    fontSize: 16,
  },
  imageArray: {
    width: "100%",
    height: "auto",
  },
};

const mapStateToProps = (state) => {
  return {
    productDetail: state.productDetail.productDetail,
    currencySelect: state.currencySelect,
    cart: state.cart,
    categories: state.categories.categories,
    customizationCost: state.payment.customizationCost,
    auth: state.firebase.auth,
    wishlist: state.wishlist,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    getProductDetail,
    addProduct,
    removeProduct,
    handleOneProduct,
    getCosts,
    addWishlistItem,
    removeWishlistItem,
    getWishlist,
  })(ProductPay)
);
